import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseActivityEmployee } from '../../interfaces/requests.model';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class ActivitiesService {
  private urlOngoing = environment.url;
  private acc = SessionStorage.getItem('currentAccount');
  constructor(public http: HttpClient) {}

  /**
   * Get employee activities
   */
  getActivities(id: string): Observable<ResponseActivityEmployee> {
    return this.http.get<ResponseActivityEmployee>(`${this.urlOngoing}/employees/${id}/activities?account=${this.acc}`, {
      headers: new HttpHeaders({
        accountId: this.acc,
      })
    });
  }
}
